import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";

export type DreRow = { mes: string; receita: number; despesas: number; resultado: number };
export type CashFlowRow = { mes: string; recebido: number; pago: number };
export type RevenueByApplicationRow = { nome: string; valor: number };
export type AgingSummaryRow = { faixa: string; quantidade: number; total: number };
export type AgingDetailRow = {
  codigo: string;
  cliente: string;
  referencia: string;
  vencimento: string;
  diasEmAtraso: number;
  faixa: string;
  valor: number;
};
export function useDreReport(months = 6): UseQueryResult<DreRow[]> {
  return useQuery({
    queryKey: ["reports", "dre", months],
    queryFn: async () => (await staffApi.get<DreRow[]>("/reports/dre", { params: { months } })).data,
  });
}

export function useCashFlowReport(months = 6): UseQueryResult<CashFlowRow[]> {
  return useQuery({
    queryKey: ["reports", "cash-flow", months],
    queryFn: async () => (await staffApi.get<CashFlowRow[]>("/reports/cash-flow", { params: { months } })).data,
  });
}

export function useRevenueByApplicationReport(): UseQueryResult<RevenueByApplicationRow[]> {
  return useQuery({
    queryKey: ["reports", "revenue-by-application"],
    queryFn: async () => (await staffApi.get<RevenueByApplicationRow[]>("/reports/revenue-by-application")).data,
  });
}

export function useAgingReport(): UseQueryResult<{ summary: AgingSummaryRow[]; detail: AgingDetailRow[] }> {
  return useQuery({
    queryKey: ["reports", "aging"],
    queryFn: async () =>
      (await staffApi.get<{ summary: AgingSummaryRow[]; detail: AgingDetailRow[] }>("/reports/aging")).data,
  });
}

export async function exportReportCsv(path: string, filename: string, params: Record<string, string | number | undefined> = {}): Promise<void> {
  const res = await staffApi.get(path, { params: { ...params, format: "csv" }, responseType: "blob" });
  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
